import apiCore from '../../utils/api-core';

export function getProducts() {
	return apiCore.get(`/api/v1/products`);
}

export function getUserProducts() {
	return apiCore.get('/api/v1/products/user');
}

export function getRoles() {
	return apiCore.get(`/api/v1/roles`);
}